<div class="container-fluid " *ngIf="!loading">
  <div class="row">
    <div class="col s12">
      <h1 class="mb-1">Dashboard</h1>
      <span class="block mt-[3px] text-gray-400 !text-[16px]">Welcome back, here's what's happening today.</span>
    </div>
  </div>

  <div class="row" *ngIf="showSetupBanner">
    <div class="col s12">
      <div class="setup-banner">
        <div class="setup-banner__content">
          <span class="material-symbols-outlined setup-banner__icon">rocket_launch</span>
          <div class="setup-banner__text">

            <div class="setup-banner__title">{{ setupBannerTitle }}</div>
            <div class="setup-banner__subtitle">
              {{ setupBannerSubtitle }}
            </div>
          </div>
        </div>
        <div class="setup-banner__actions setup-banner__actions--wrap">
          <button mat-raised-button color="primary" (click)="resumeSetup()">
            {{ setupBannerCta }}
          </button>
          <!-- <button mat-stroked-button type="button" (click)="takeProductTour()">
            Take tour
          </button> -->
          <button mat-stroked-button type="button" (click)="tryDemoData()"
            *ngIf="trialOnboardingHelp.canShowOptionalHelpLinks()">
            {{ trialOnboardingHelp.isShowingDemoData() ? 'Hide' : 'Try' }} sample data
          </button>
          <button mat-stroked-button (click)="dismissSetupBanner()">
            Not now
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="row employee-cards db-style-1" tourAnchor="DashboardInforMativeCard">
    <div class="col s6 m6 xl3 l6">
      <div *ngIf="isloading">
        <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
          [theme]="{ 'border-radius': '2', height: '65px', margin: '5px' }"></ngx-skeleton-loader>
      </div>
      <mat-card *ngIf="!isloading" class="total-employee-card" id="total_employee_section"
        (click)="routeToFilterEmployee('all')">
        <mat-card-content>
          <div class="row">
            <div class="col s12">
              <div class="employee-card-icon-div employee-card-icon-div-bg-total employee-card-icon-div-color-total">
                <span class="material-symbols-outlined"> group </span>
              </div>
            </div>
          </div>
          <div class="row db-style-2">
            <div class="col s12">
              <h1 class="employee-card-icon-div-color-total db-style-3">
                {{ isTourActive() ? onlineUsers + offlineUsers + idleUsers : 100 }}
              </h1>
            </div>
          </div>
          <div class="row db-style-4">
            <div class="col s12 m6 l6 xl6">
              <p class="employee-card-icon-div-color-total padding_text">Employees</p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="col s6 m6 xl3 l6">
      <div *ngIf="isloading">
        <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
          [theme]="{ 'border-radius': '2', height: '65px', margin: '5px' }"></ngx-skeleton-loader>
      </div>

      <mat-card *ngIf="!isloading" class="total-employee-card" [matMenuTriggerFor]="tooltipOnline"
        (click)="routeToFilterEmployee('online')" #onlineMenuTrigger="matMenuTrigger" (mouseenter)="openOnlineMenu()">
        <mat-card-content>
          <div class="row">
            <div class="col s12">
              <div class="employee-card-icon-div employee-card-icon-div-bg-online employee-card-icon-div-color-online">
                <span class="material-symbols-outlined"> person </span>
              </div>
            </div>
          </div>
          <div class="row db-style-2">
            <div class="col s12">
              <h1 class="employee-card-icon-div-color-online">{{ isTourActive() ? onlineUsers : 100 }}</h1>
            </div>
          </div>
          <div class="row db-style-5">
            <div class="col s12">
              <p class="employee-card-icon-div-color-online">Online</p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-menu #tooltipOnline="matMenu" class="custom-tooltip-count" [overlapTrigger]="false"
        (mouseenter)="cancelCloseTimer()">
        <div class="tooltip-content db-style-7">
          <p><b>Online Employees</b></p>
          <ul>
            <li *ngFor="let employee of onlineEmployee">{{employee.wpEmployee.name}}</li>
            <li *ngIf="!onlineEmployee || !onlineEmployee.length">No user online</li>
          </ul>
        </div>
      </mat-menu>
    </div> 
    
    IDLE EMPLOYEES CARD 
    <div class="col s6 m6 xl3 l6">
      <div *ngIf="isloading">
        <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
          [theme]="{ 'border-radius': '2', height: '65px', margin: '5px' }"></ngx-skeleton-loader>
      </div>

      <mat-card *ngIf="!isloading" class="total-employee-card" [matMenuTriggerFor]="tooltipIdle"
        #idleMenuTrigger="matMenuTrigger" (mouseenter)="openIdleMenu()">
        <mat-card-content>
          <div class="row">
            <div class="col s12">
              <div
                class="employee-card-icon-div employee-card-icon-div-bg-idle employee-card-icon-div-color-idle">
                <span class="material-symbols-outlined"> timer </span>
              </div>
            </div>
          </div>
          <div class="row db-style-2">
            <div class="col s12">
              <h1 class="employee-card-icon-div-color-idle">{{ isTourActive() ? idleUsers : 100 }}</h1>
            </div>
          </div>
          <div class="row db-style-5">
            <div class="col s12">
              <p class="employee-card-icon-div-color-idle">Idle</p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-menu #tooltipIdle="matMenu" class="custom-tooltip-count" [overlapTrigger]="false"
        (mouseenter)="cancelCloseTimer()">
        <div class="tooltip-content db-style-7">
          <p><b>Idle Employees</b></p>
          <ul>
            <li *ngFor="let employee of idleEmployee">
              {{employee.wpEmployee.name}}
              <span *ngIf="getIdleStartTime(employee)" style="color: #666; font-size: 0.9em; margin-left: 8px;">
                (Idle since {{getIdleStartTime(employee)}})
              </span>
            </li>
            <li *ngIf="!idleEmployee || !idleEmployee.length">No user idle</li>
          </ul>
        </div>
      </mat-menu>
    </div>
    
    <div class="col s6 m6 xl3 l6">
      <div *ngIf="isloading">
        <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
          [theme]="{ 'border-radius': '2', height: '65px', margin: '5px' }"></ngx-skeleton-loader>
      </div>

      <mat-card *ngIf="!isloading" class="total-employee-card" [matMenuTriggerFor]="tooltipOffline"
        (click)="routeToFilterEmployee('offline')" #offlineMenuTrigger="matMenuTrigger"
        (mouseenter)="openOfflineMenu()">

        <mat-card-content>
          <div class="row">
            <div class="col s12">
              <div
                class="employee-card-icon-div employee-card-icon-div-bg-offline employee-card-icon-div-color-offline">
                <span class="material-symbols-outlined"> person_off </span>
              </div>
            </div>
          </div>
          <div class="row db-style-2">
            <div class="col s12">
              <h1 class="employee-card-icon-div-color-offline">{{ isTourActive() ? offlineUsers : 100 }}</h1>
            </div>
          </div>
          <div class="row db-style-5">
            <div class="col s12">
              <p class="employee-card-icon-div-color-offline">Offline</p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-menu #tooltipOffline="matMenu" class="custom-tooltip-count" [overlapTrigger]="false"
        (mouseenter)="cancelCloseTimer()">
        <div class="tooltip-content db-style-7">
          <p><b>Offline Employees</b></p>
          <ul>
            <li *ngFor="let employee of offlineEmployee">
              {{employee.wpEmployee.name}}
              <span *ngIf="isInvitedUser(employee)" style="color: #d1a600; font-size: 0.9em; margin-left: 8px;">
                (Invited)
              </span>
              <span *ngIf="!isInvitedUser(employee) && getOfflineLastActiveTime(employee)" style="color: #666; font-size: 0.9em; margin-left: 8px;">
                (Last active {{getOfflineLastActiveTime(employee)}})
              </span>
            </li>
            <li *ngIf="!offlineEmployee || !offlineEmployee.length">No user offline</li>
          </ul>
        </div>
      </mat-menu>
    </div>

    <div class="col s6 m6 xl3 l6">
      <div *ngIf="isloading">
        <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
          [theme]="{ 'border-radius': '2', height: '65px', margin: '5px' }"></ngx-skeleton-loader>
      </div>
      <mat-card *ngIf="!isloading" class="total-employee-card">
        <mat-card-content>
          <div class="row">
            <div class="col s12">
              <div class="employee-card-icon-div employee-card-icon-div-bg-team employee-card-icon-div-color-team">
                <span class="material-symbols-outlined"> groups </span>
              </div>
            </div>
          </div>
          <div class="row db-style-2">
            <div class="col s12">
              <h1 class="employee-card-icon-div-color-team db-style-3">
                {{isTourActive() ? teamSize : 100}}
              </h1>
            </div>
          </div>
          <div class="row db-style-4">
            <div class="col s6">
              <p class="employee-card-icon-div-color-team padding_text db-style-8">
                Teams
              </p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div> -->

  <div class="px-3 mb-5 w-full flex items-center gap-4 justify-between sm:flex-nowrap">
    <div class="flex items-center gap-4 justify-between w-full flex-wrap">
      <status-card class="flex-1 extra-small:min-w-[210px]" [cardColor]="'#5459d1'" [backgroundColorIcon]="'#5459d130'"
        [iconName]="'group'" [cardTitle]="'Employees'" [buttonTitle]="'View All'"
        [cardCount]="isTourActive() ? allUsersCount : 100" [loading]="isloading" [routingPath]="'all'"
        [isShowTooltip]="false" [isShowQuota]="quotaAllowedToCreateUser"></status-card>
      <status-card class="flex-1 extra-small:min-w-[210px]" [cardColor]="'#21bc68'" [backgroundColorIcon]="'#e0f0e78c'"
        [iconName]="'person'" [cardTitle]="'Online'" [buttonTitle]="'Details'"
        [cardCount]="isTourActive() ? onlineUsersForCard.length : 100" [loading]="isloading" [routingPath]="'online'"
        [isShowTooltip]="true" [toolTipContent]="onlineUsersForCard"></status-card>
      <status-card class="flex-1 extra-small:min-w-[210px]" [cardColor]="'#bc214f'" [backgroundColorIcon]="'#bc214f1a'"
        [iconName]="'person_off'" [cardTitle]="'Offline'" [buttonTitle]="'Details'"
        [cardCount]="isTourActive() ? offlineUsersForCard.length : 100" [loading]="isloading"
        [routingPath]="'offline&auto-logout'" [isShowTooltip]="true"
        [toolTipContent]="offlineUsersForCard"></status-card>
    </div>
    <div class="flex items-center gap-4 justify-between w-full flex-wrap">
      <status-card class="flex-1 extra-small:min-w-[210px]" [cardColor]="'#ff9900'" [backgroundColorIcon]="'#ff99001a'"
        [iconName]="'timer'" [cardTitle]="'Idle'" [buttonTitle]="'Details'"
        [cardCount]="isTourActive() ? idleUsersForCard.length : 100" [loading]="isloading" [routingPath]="'idle'"
        [isShowTooltip]="true" [toolTipContent]="idleUsersForCard"></status-card>
      <status-card class="flex-1 extra-small:min-w-[210px]" [cardColor]="'#ff0000'" [backgroundColorIcon]="'#ff00001a'"
        [iconName]="'person_cancel'" [cardTitle]="'Absent'" [buttonTitle]="'Details'"
        [cardCount]="isTourActive() ? absentUsersList.length : 100" [loading]="isloading" [isShowTooltip]="true"
        [toolTipContent]="absentUsersList" [routingPath]="'absent'"></status-card>
      <status-card class="flex-1 extra-small:min-w-[210px]" [cardColor]="'#e2b300'" [backgroundColorIcon]="'#f9c80e1a'"
        [iconName]="'person_add'" [cardTitle]="'Invited'" [buttonTitle]="'Details'"
        [cardCount]="isTourActive() ? invitedUsersList.length : 100" [loading]="isloading" [routingPath]="'invited'"
        [isShowTooltip]="true" [toolTipContent]="invitedUsersList"></status-card>
    </div>
  </div>

  <div class="row" id="most_used_apps_section" tourAnchor="mostUsedAppDashboard">
    <div class="col s12 m6 lg12 xl6 db-style-9">
      <mat-card class="graph-card">
        <div class="row most-use-row">
          <div class="col s12 lg6">
            <h4>Most Used application</h4>
          </div>
          <div class="col s12 lg6 db-style-10">
            <mat-form-field class="date-range-picker-form-field">
              <mat-date-range-input [disabled]="!isTourActive()" [rangePicker]="picker" [min]="minApplicationUsageDate"
                [max]="maxApplicationUsageDate">
                <input matStartDate [value]="startdate" placeholder="Start date"
                  (dateChange)="onStartDateChange($event)" />
                <input matEndDate [value]="enddate" placeholder="End date" (dateChange)="onEndDateChange($event)" />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>
        <mat-card-content class="most-use-card-content">
          <div *ngIf="isPiechartLoad">
            <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
              [theme]="{ 'border-radius': '2', height: '600px', margin: '5px' }"></ngx-skeleton-loader>
          </div>
          <div class="row application-usage-container"
            [ngStyle]="{'display':isPiechartLoad ? 'none':'block','visibility':isPiechartLoad?'hidden':'visible'}">
            <div class="col s12">
              <div class="db-style-11">
                <application-usage [isChartWebBrowserUser]="false"></application-usage>
              </div>
            </div>
            <div class="col s12 progressbar-component db-style-12">
              <progressbar [isDashboard]="true" [isDataWebsiteUsage]="false"></progressbar>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div>
      </div>
    </div>

    <!-- This will come later when website usage comes for release -->
    <div class="col s12 m6 lg12 xl6 db-style-9">
      <mat-card class="graph-card">
        <div class="row most-use-row">
          <div class="col s12 lg6 most-use-contain">
            <h4 class="title-with-beta">
              <span>Most Used Websites</span>
              <span class="beta-badge" *ngIf="sysConfig.isBeta" [matTooltip]="sysConfig.betaTooltip">
                <i>Beta</i>
              </span>
            </h4>
          </div>
          <div class="col s12 lg6 db-style-10">
            <mat-form-field class="date-range-picker-form-field">
              <mat-date-range-input [disabled]="!isTourActive()" [rangePicker]="pickerWebsiteUsage"
                [min]="minWebsiteUsageDate" [max]="maxWebsiteUsageDate">
                <input matStartDate [value]="startDateForInput" placeholder="Start date"
                  (dateChange)="onStartDateChangeWebsiteUsageChart($event)" />
                <input matEndDate [value]="endDateForInput" placeholder="End date"
                  (dateChange)="onEndDateChangeWebsiteUsageChart($event)" />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="pickerWebsiteUsage"></mat-datepicker-toggle>
              <mat-date-range-picker #pickerWebsiteUsage></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>

        <mat-card-content class="most-use-card-content">
          <div *ngIf="isPieChartLoadWebsite">
            <ngx-skeleton-loader style="margin: 20px 0px; width: 100%"
              [theme]="{ 'border-radius': '2', height: '600px', margin: '5px' }"></ngx-skeleton-loader>
          </div>
          <div class="row application-usage-container"
            [ngStyle]="{'display':isPieChartLoadWebsite ? 'none':'block','visibility':isPieChartLoadWebsite?'hidden':'visible'}">
            <div class="col s12">
              <div class="db-style-11">
                <application-usage [isChartWebBrowserUser]="true"></application-usage>
              </div>
            </div>
            <div class="col s12 progressbar-component db-style-12">
              <progressbar [isDashboard]="true" [isDataWebsiteUsage]="true"></progressbar>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div>
      </div>
    </div>

  </div>

  <div class="row">
    <div class="col s12">
      <!-- Removed because we show a separate button for screenshots and time line is a single tab -->
      <!-- <button mat-stroked-button class="timeline-section-btn {{ timelineBackground }}"
        (click)="getDashboardSection('timeline')">
        Timeline
      </button> -->

      <!-- Removed because we show a separate button for screenshots -->
      <!-- <button id="screenShotSection" tourAnchor="ScreenShotDashboard" mat-stroked-button
        class="timeline-section-btn {{ screenshotBackground }}" (click)="getDashboardSection('screenshot')">
        Screen Shots
      </button> -->
    </div>
  </div>

  <div class="row" *ngIf="timelineSection" id="timeline_section" tourAnchor="TimelineDashboard">
    <div class="col s12">
      <mat-card class="fluid-ss timeline-card">
        <div class="timeline-filter-header">
          <div class="filter-header">
            <h4>
              Employees Work Timeline
            </h4>

            <div class="filter-options timeline-toolbar">
              <div class="timeline-toolbar__modes">
                <div class="timeline-datepicker view-mode-toggle db-style-10" aria-label="Timeline range length">
                  <button mat-button type="button" class="mode-btn" [class.active]="isSingleDayActive"
                    (click)="setSingleDay()" matTooltip="Single day (24 hours)">
                    24 Hours
                  </button>
                  <button mat-button type="button" class="mode-btn" [class.active]="isVirtualShiftActive"
                    (click)="setVirtualShift()" matTooltip="Two calendar days (48 hours)">
                    48 Hours
                  </button>
                </div>
              </div>

              <div class="timeline-toolbar__shift">
                <div class="shift-time-picker">
                  <div class="shift-time-picker-content-wrapper">
                    <div class="shift-time-field-group">
                      <span class="shift-time-field-group__caption" id="timeline-shift-start-caption">Shift Start</span>
                      <mat-form-field appearance="fill" floatLabel="never"
                        class="date-range-picker-form-field shift-time-mat-field" subscriptSizing="dynamic">
                        <input matInput type="time" step="300" aria-labelledby="timeline-shift-start-caption"
                          [(ngModel)]="timelineStartTime" (ngModelChange)="scheduleTimelineShiftTimeFilterApply()">
                      </mat-form-field>
                    </div>
                    <div class="shift-time-field-group">
                      <span class="shift-time-field-group__caption" id="timeline-shift-end-caption">Shift End</span>
                      <mat-form-field appearance="fill" floatLabel="never"
                        class="date-range-picker-form-field shift-time-mat-field" subscriptSizing="dynamic">
                        <input matInput type="time" step="300" aria-labelledby="timeline-shift-end-caption"
                          [(ngModel)]="timelineEndTime" (ngModelChange)="scheduleTimelineShiftTimeFilterApply()">
                      </mat-form-field>
                    </div>
                  </div>
                  <button mat-stroked-button type="button" color="primary" class="shift-clear-btn"
                    (click)="clearTimelineShiftSelection()" [disabled]="!hasTimelineShiftSelection">
                    Clear
                  </button>
                </div>
              </div>

              <div class="timeline-toolbar__date">
                <div class="timeline-date-nav" role="group" aria-label="Timeline date">
                  <button type="button" mat-icon-button class="timeline-nav-btn" [disabled]="_isStackbarLoading"
                    (click)="onPreviousDate()" matTooltip="Previous day">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                  </button>
                  <mat-form-field *ngIf="isSingleDayActive"
                    class="date-range-picker-form-field timeline-date-field timeline-date-field--single"
                    subscriptSizing="dynamic">
                    <input matInput [matDatepicker]="timelineSingleDp" [ngModel]="timelineSingleDayModel"
                      (ngModelChange)="onTimelineSingleDayPicked($event)" [min]="timelineMinDate"
                      [max]="timelineMaxDate" placeholder="Date" readonly>
                    <mat-datepicker-toggle matIconSuffix [for]="timelineSingleDp"></mat-datepicker-toggle>
                    <mat-datepicker #timelineSingleDp></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field *ngIf="!isSingleDayActive"
                    class="date-range-picker-form-field timeline-date-field timeline-date-field--range"
                    subscriptSizing="dynamic">
                    <mat-date-range-input [formGroup]="timeline48Range" [rangePicker]="timelineRangeDp"
                      [min]="timelineMinDate" [max]="timelineMatRangeMax">
                      <input matStartDate formControlName="start" placeholder="Start date" readonly>
                      <input matEndDate formControlName="end" placeholder="End date" readonly>
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="timelineRangeDp"></mat-datepicker-toggle>
                    <mat-date-range-picker #timelineRangeDp
                      (closed)="onTimeline48RangeClosed()"></mat-date-range-picker>
                  </mat-form-field>
                  <button type="button" mat-icon-button class="timeline-nav-btn" [disabled]="_isStackbarLoading"
                    (click)="onNextDate()" matTooltip="Next day">
                    <mat-icon>keyboard_arrow_right</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="filter-options">
            <div class="filter-partition">
              <!-- Legacy duplicate shift / date controls removed. -->
            </div>

            <div class="filter-partition">
              <!-- Team selection -->
              <mat-form-field class="timeline-datepicker">
                <mat-select placeholder="Select Team" (selectionChange)="teamSelectionChange()"
                  [(ngModel)]="selectedTeam" [disabled]="!isTourActive()" style="font-size: 15px;">
                  @for (team of teamsListForFilter; track $index) {
                  <mat-option [value]="team.title.rendered" (click)="teamSelected(team)">
                    {{team.title.rendered}}
                  </mat-option>
                  } @empty {
                  <mat-option disabled>No Teams Available</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <!-- Employee search component -->
              <app-employee-search [userList]="userList" [placeholder]="'Search Employee'" [isNeedUserReturn]="true"
                class="!w-full" [isInputSearch]="true" [selectedEmployeeId]="searchStack"
                (searchEmployeeName)="searchTimelineData($event)">
              </app-employee-search>
            </div>
          </div>
        </div>

        <div *ngIf="_isStackbarLoading">
          <ngx-skeleton-loader style="margin: 20px 0px; width: 100%" [theme]="{
              'border-radius': '2',
              height: '400px',
              margin: '5px'
            }"></ngx-skeleton-loader>
        </div>

        <!-- Virtual Shift Timeline Header - Aligned with chart data area -->
        <div class="chart-parent-div">
          <app-stacked-chart *ngIf="
            stackedChartData && stackedChartData.length && !_isStackbarLoading
          " [type]="'horizontal'" [data]="stackedChartData" [minValue]="x_min" [maxValue]="x_max"
            [labels]="stackedChartlabel" [tempDataTooltip]="tempDataTooltip" [newSessionData]="newSessionTimeline"
            [id]="stackedChartIds" [startDate]="timelineChartStartLocal" [endDate]="timelineChartEndLocal"
            [workingHoursStart]="timelineStartTime" [workingHoursEnd]="timelineEndTime"
            [conductTimelogs]="timelineConductTimelogs"
            [attr.data-key]="page + '_' + selectedTeam + '_' + searchStack + '_' + (isSingleDayActive ? '24h' : '48h') + '_' + (timelineChartStartLocal || '') + '_' + (timelineChartEndLocal || '')"></app-stacked-chart>
        </div>

        <div></div>

        <div class="empty_list z-depth-2 remove-border" *ngIf="
            !_isStackbarLoading && stackedChartData && !stackedChartData.length
          ">
          <img src="assets/images/empty_list.png" alt="empty list image" />
        </div>
        <div class="row">
          <div class="timelin-pagination-div" *ngIf="totalStack_user && totalStack_user != 0">
            <div class="timeline-pagination">
              <p>{{startPage}}-{{endPage}} of {{totalStack_user}}</p>
            </div>
            <button (click)="WeekPrevNextAction(true)">
              <i class="material-icons db-style-19" [ariaDisabled]="page == 1">keyboard_arrow_left</i>
            </button>
            <button (click)="WeekPrevNextAction(false)">
              <i class="material-icons db-style-19">keyboard_arrow_right</i>
            </button>
          </div>
        </div>

      </mat-card>
    </div>
  </div>

  <!-- Project Time Logs Section -->
  <div class="row" *ngIf="isConductIntegrated" id="conduct_timelogs_section">
    <div class="col s12">
      <mat-card class="fluid-ss mb-6">
        <mat-card-content class="p-5">
          <!-- Header with Navigation & Action -->
          <div class="flex items-center justify-between mb-5 border-b border-slate-200 pb-3 flex-wrap gap-3">
            <div class="flex items-center gap-3">
              <img src="assets/rao_conduct_logo_blue.png" alt="Conduct"
                class="w-9 h-9 rounded-lg object-contain shrink-0" />
              <div>
                <h3 class="m-0 text-base sm:text-lg font-semibold text-slate-800 flex items-center gap-2">
                  Employees Time Logs
                  <span *ngIf="!isImportingConductTimelogs"
                    class="px-2.5 py-0.5 text-xs font-semibold bg-indigo-50 text-[#5459d1] rounded-full border border-indigo-100">
                    {{ groupedConductProjects.length }} {{ groupedConductProjects.length === 1 ? 'Project' : 'Projects'
                    }}
                  </span>
                  <span *ngIf="isImportingConductTimelogs" class="inline-flex items-center">
                    <ngx-skeleton-loader count="1"
                      [theme]="{ 'border-radius': '9999px', height: '20px', width: '68px', margin: '0' }">
                    </ngx-skeleton-loader>
                  </span>
                </h3>
                <span class="text-xs text-slate-400 font-normal">
                  Daily project hours and tasks synced from Conduct
                </span>
              </div>
            </div>

            <div class="flex items-center gap-2 sm:gap-3 flex-wrap">
              <div class="timeline-date-nav" role="group" aria-label="Conduct log date">
                <button type="button" mat-icon-button class="timeline-nav-btn"
                  [disabled]="isImportingConductTimelogs || isConductPreviousDisabled" (click)="onConductPreviousDate()"
                  matTooltip="Previous day">
                  <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
                <mat-form-field class="date-range-picker-form-field timeline-date-field timeline-date-field--single"
                  subscriptSizing="dynamic">
                  <input matInput [matDatepicker]="conductDp" [ngModel]="conductDateModel" [min]="minConductDate"
                    [max]="maxConductDate" (ngModelChange)="onConductDatePicked($event)" placeholder="Date" readonly>
                  <mat-datepicker-toggle matIconSuffix [for]="conductDp"></mat-datepicker-toggle>
                  <mat-datepicker #conductDp></mat-datepicker>
                </mat-form-field>
                <button type="button" mat-icon-button class="timeline-nav-btn"
                  [disabled]="isImportingConductTimelogs || isConductNextDisabled" (click)="onConductNextDate()"
                  matTooltip="Next day">
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <!-- Skeleton Loading State -->
          <div *ngIf="isImportingConductTimelogs"
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            <div *ngFor="let s of [1, 2, 3, 4]"
              class="relative bg-white rounded-xl border border-solid border-gray-200 p-4 shadow-2xs flex flex-col justify-between overflow-hidden">

              <!-- Subtle Top Accent Skeleton -->
              <div class="absolute top-0 left-0 right-0 h-1 bg-slate-200"></div>

              <div>
                <!-- Top Row: Project Badge & Task Pill Skeleton -->
                <div class="flex items-center justify-between gap-2 mb-3 pt-1">
                  <ngx-skeleton-loader count="1"
                    [theme]="{ 'border-radius': '6px', height: '22px', width: '120px', margin: '0' }">
                  </ngx-skeleton-loader>
                  <ngx-skeleton-loader count="1"
                    [theme]="{ 'border-radius': '9999px', height: '18px', width: '48px', margin: '0' }">
                  </ngx-skeleton-loader>
                </div>

                <!-- Middle Hero: Logged Hours Skeleton -->
                <div class="mb-3">
                  <ngx-skeleton-loader count="1"
                    [theme]="{ 'border-radius': '4px', height: '16px', width: '100px', margin: '0' }">
                  </ngx-skeleton-loader>
                </div>
              </div>

              <!-- Bottom Row: Contributor Avatars & Direct Link Affordance Skeleton -->
              <div class="pt-3 border-t border-slate-100 flex items-center justify-between gap-2 mt-2">
                <div class="flex items-center -space-x-2">
                  <ngx-skeleton-loader count="1"
                    [theme]="{ 'border-radius': '50%', height: '26px', width: '26px', margin: '0' }">
                  </ngx-skeleton-loader>
                  <ngx-skeleton-loader count="1"
                    [theme]="{ 'border-radius': '50%', height: '26px', width: '26px', margin: '0' }">
                  </ngx-skeleton-loader>
                </div>
                <ngx-skeleton-loader count="1"
                  [theme]="{ 'border-radius': '4px', height: '16px', width: '60px', margin: '0' }">
                </ngx-skeleton-loader>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div *ngIf="!isImportingConductTimelogs && (!groupedConductProjects || groupedConductProjects.length === 0)"
            class="py-10 px-4 text-center rounded-xl border border-dashed border-slate-200 bg-slate-50/60 flex flex-col items-center justify-center">
            <div
              class="w-12 h-12 rounded-2xl bg-white border border-slate-200/80 shadow-2xs flex items-center justify-center mb-3 p-2.5">
              <img src="assets/rao_conduct_logo_blue.png" alt="" class="w-full h-full object-contain opacity-70" />
            </div>
            <p class="text-sm font-semibold text-slate-700 m-0">No project time logged for this date</p>
            <p class="text-xs text-slate-400 mt-1 mb-4 max-w-sm">
              Track time on tasks in Conduct to see daily project breakdowns here.
            </p>
            <button mat-stroked-button (click)="navigateToConductLogs()"
              class="!text-xs font-medium !text-[#5459d1] !border-[#5459d1] inline-flex items-center gap-1.5 hover:!bg-[#5459d1]/5">
              <mat-icon class="!text-sm !w-4 !h-4 leading-none text-[#5459d1]">open_in_new</mat-icon>
              <span>View Conduct Timelogs</span>
            </button>
          </div>

          <!-- Compact Project Cards Grid -->
          <div *ngIf="!isImportingConductTimelogs && groupedConductProjects && groupedConductProjects.length > 0"
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            <div *ngFor="let proj of groupedConductProjects"
              (click)="navigateToConductLogs(proj.project_id, proj.project_name)"
              class="group relative bg-white rounded-xl border border-solid border-gray-200 hover:border-[#5459d1]/40 p-4 shadow-2xs hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 cursor-pointer flex flex-col justify-between overflow-hidden">

              <!-- Subtle Top Accent Line -->
              <div class="absolute top-0 left-0 right-0 h-1" [style.backgroundColor]="proj.colorPalette.barHex"></div>

              <div>
                <!-- Top Row: Project Icon + Title & Tasks Pill -->
                <div class="flex items-center justify-between gap-2 mb-3.5 pt-1">
                  <div class="flex items-center gap-2 min-w-0">
                    <span
                      class="inline-flex items-center justify-center w-7 h-7 rounded-lg border shrink-0"
                      [ngClass]="[proj.colorPalette.tagBg, proj.colorPalette.tagText, proj.colorPalette.tagBorder]">
                      <mat-icon class="!text-sm !w-4 !h-4 leading-none">folder</mat-icon>
                    </span>
                    <span class="text-sm font-semibold text-slate-800 truncate" [matTooltip]="proj.project_name">
                      {{ proj.project_name }}
                    </span>
                  </div>
                  <span class="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-0.5 rounded-full shrink-0">
                    {{ proj.total_tasks_count }} {{ proj.total_tasks_count === 1 ? 'task' : 'tasks' }}
                  </span>
                </div>

                <!-- Middle Hero: Logged Hours + Clock Visual Indicator -->
                <div class="mb-4 flex items-center justify-between gap-3">
                  <div>
                    <div class="text-[11px] uppercase tracking-wider text-slate-400 font-semibold mb-1">Time Logged</div>
                    <div class="text-2xl font-bold text-slate-800 tracking-tight flex items-baseline gap-1.5">
                      <span>{{ proj.total_worked_hours }}</span>
                    </div>
                  </div>
                  <div
                    class="w-10 h-10 rounded-xl bg-slate-50 border border-slate-100 flex items-center justify-center text-slate-400 group-hover:text-[#5459d1] group-hover:bg-[#5459d1]/5 group-hover:border-[#5459d1]/20 transition-all duration-200 shrink-0">
                    <mat-icon class="!text-xl !w-5 !h-5 leading-none">schedule</mat-icon>
                  </div>
                </div>
              </div>

              <!-- Bottom Row: Contributor Avatars & Direct Link Affordance -->
              <div class="pt-3 border-t border-slate-100 flex items-center justify-between gap-2 mt-2">
                <!-- Contributors with Context -->
                <div class="flex items-center gap-2 min-w-0">
                  <!-- 1 Contributor: Avatar + Name -->
                  <div *ngIf="proj.contributors && proj.contributors.length === 1" class="flex items-center gap-2 min-w-0">
                    <ngx-avatars [name]="proj.contributors[0].name || 'User'" size="26" [initialsSize]="2" [textSizeRatio]="3"
                      class="rounded-full ring-2 ring-white inline-block shadow-2xs shrink-0" [matTooltip]="proj.contributors[0].name">
                    </ngx-avatars>
                    <span class="text-xs font-medium text-slate-600 truncate max-w-[110px]" [matTooltip]="proj.contributors[0].name">
                      {{ proj.contributors[0].name }}
                    </span>
                  </div>

                  <!-- Multiple Contributors: Stacked Avatars -->
                  <div *ngIf="proj.contributors && proj.contributors.length > 1" class="flex items-center -space-x-2 overflow-hidden py-0.5">
                    <ng-container *ngFor="let c of proj.contributors.slice(0, 3)">
                      <ngx-avatars [name]="c.name || 'User'" size="26" [initialsSize]="2" [textSizeRatio]="3"
                        class="rounded-full ring-2 ring-white inline-block shadow-2xs" [matTooltip]="c.name">
                      </ngx-avatars>
                    </ng-container>
                    <span *ngIf="proj.contributors.length > 3"
                      class="inline-flex items-center justify-center w-6.5 h-6.5 text-[10px] font-bold text-slate-600 bg-slate-100 rounded-full ring-2 ring-white shrink-0">
                      +{{ proj.contributors.length - 3 }}
                    </span>
                  </div>

                  <!-- Fallback if no contributors -->
                  <div *ngIf="!proj.contributors || proj.contributors.length === 0" class="flex items-center gap-1 text-xs text-slate-400">
                    <mat-icon class="!text-sm !w-4 !h-4 leading-none text-slate-400">person_outline</mat-icon>
                    <span>Conduct</span>
                  </div>
                </div>

                <!-- Action Link Indicator -->
                <span
                  class="text-xs font-semibold text-[#5459d1] group-hover:translate-x-0.5 transition-transform inline-flex items-center gap-1 shrink-0">
                  <span>View Details</span>
                  <mat-icon class="!text-sm !w-4 !h-4 leading-none">arrow_forward</mat-icon>
                </span>
              </div>
            </div>
          </div>

          <!-- Bottom Action: View Full Workbench aligned to bottom right -->
          <div *ngIf="!isImportingConductTimelogs && groupedConductProjects && groupedConductProjects.length > 0"
            class="mt-4 pt-3 border-t border-slate-100 flex justify-end items-center">
            <button color="primary" (click)="navigateToConductLogs()"
              class="bg-transparent h-9 flex items-center justify-center gap-1 px-3 sm:px-4 font-semibold text-xs !text-[#5459d1] border-none outline-none cursor-pointer"
              matTooltip="View All Conduct Timelogs">
              <span class="leading-none">View Time Logs</span>
              <mat-icon class="!text-xs !w-4 !h-4 leading-none !mr-0 !ml-0.5">arrow_forward</mat-icon>
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Conduct Timelogs Detail Drawer now hosted via centralized App Shared Drawer -->

  <mat-card class="fluid-ss screenshot-dashbord-card" *ngIf="screenshotSection" id="ss_section">
    <div class="row ss-fluid-row most-use-row">
      <div class="col s12 m12 most-use-contain db-style-1"
        style="display: flex; align-items: center; justify-content: space-between;">
        <h4 *ngIf="!selectEnable" style="margin: 0;">Screenshots</h4>

        <div class="filter-section d-flex items-center">
          <mat-form-field class="filter-search" appearance="fill">
            <mat-label>Employees</mat-label>
            <mat-select placeholder="Select Employees" [formControl]="employeeMultiCtrl">
              <mat-option value="">All Employees</mat-option>
              <mat-option *ngFor="let user of userList" [value]="user.id">{{user.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="timePicker screenshot-mat-datetime-filter">
            <mat-form-field appearance="fill" floatLabel="always"
              class="screenshot-range-field date-range-picker-form-field" subscriptSizing="dynamic">
              <mat-label>Date range</mat-label>
              <mat-date-range-input [formGroup]="screenshotDateRange" [rangePicker]="screenshotRangeDp"
                [min]="timelineMinDate" [max]="timelineMaxDate">
                <input matStartDate formControlName="start" placeholder="Start" readonly>
                <input matEndDate formControlName="end" placeholder="End" readonly>
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="screenshotRangeDp"></mat-datepicker-toggle>
              <mat-date-range-picker #screenshotRangeDp
                (closed)="onDashboardScreenshotFilterChange()"></mat-date-range-picker>
            </mat-form-field>
            <mat-form-field appearance="fill" floatLabel="always"
              class="screenshot-time-field date-range-picker-form-field" subscriptSizing="dynamic">
              <mat-label>Start time</mat-label>
              <input matInput type="time" step="1" [(ngModel)]="screenshotStartTimeStr"
                (change)="onDashboardScreenshotFilterChange()">
            </mat-form-field>
            <mat-form-field appearance="fill" floatLabel="always"
              class="screenshot-time-field date-range-picker-form-field" subscriptSizing="dynamic">
              <mat-label>End time</mat-label>
              <input matInput type="time" step="1" [(ngModel)]="screenshotEndTimeStr"
                (change)="onDashboardScreenshotFilterChange()">
            </mat-form-field>
            <mat-icon class="datepicker-open-trigger db-style-20" (click)="openDatepicker()">today</mat-icon>
          </div>
        </div>

      </div>
    </div>

    <div class="screenshot-time-hint" *ngIf="screenshotSection && regionHint" role="note">
      <mat-icon class="hint-icon" fontSet="material-symbols-outlined">public</mat-icon>
      <span class="hint-text">{{ regionHint }}</span>
    </div>

    <div *ngIf="isloading">
      <div class="row">
        <div class="col s12 m6 l3" *ngFor="let loader of skeletonLoaders">
          <ngx-skeleton-loader style="margin: 20px 0px; width: 100%" [theme]="skeletonTheme">
          </ngx-skeleton-loader>
        </div>
      </div>
    </div>

    <div class="row screenshot-card-main-row db-style-1">
      <div class="col s6 m6 l6 xl4 screenshot-card" [ngStyle]="{
          display: PhotoList.length ? 'block' : 'none',
          visibility: PhotoList.length ? 'visible' : 'hidden'
        }" *ngFor="let image of PhotoList">
        <!-- <ng-container *ngFor="let imageInfo of image | keyvalue"> -->
        <div>
          <!-- *ngIf="imageInfo.key != '_links' && imageInfo.value.user_id !== '0'" -->
          <mat-card class="ss-card">

            <div class="row db-style-21">
              <div class="col s12 db-style-22">

                <a class=" screenshot_box waves-effect waves-light" href="{{ image.image_url }}"
                  data-fancybox="gallery">
                  <img src="{{ image.image_url }}" alt="screenshot image" class="responsive-img ss-img" />
                </a>

                <div class="absolute-info" *ngIf="isAdmin">
                  <button mat-mini-fab class="info-button" [matMenuTriggerFor]="menu" [ngStyle]="{transform: 'scale(0.8)'
              }">
                    <span class="material-symbols-outlined">more_vert</span>
                  </button>

                  <mat-menu #menu="matMenu">
                    <div mat-menu-item class="dropdown-menu-button" (click)="removeScreenShot(image)">
                      <span class="material-symbols-outlined delete"> delete </span>
                      <span class="delete">
                        &nbsp; &nbsp; Delete
                      </span>
                    </div>
                    <div mat-menu-item class="dropdown-menu-button" (click)="downloadScreenShot(image)">
                      <span class="material-symbols-outlined download"> download </span>
                      <span class="download">
                        &nbsp; &nbsp; Download
                      </span>
                    </div>
                  </mat-menu>
                </div>

                <div *ngIf="image.app_name" class="absolute-badge">
                  {{ trimName(image.app_name | slice:0:30) }}
                </div>
              </div>

            </div>

            <div class="row db-style-2">
              <div class="col s12 m6 l7 xl7 ss-card-profile-col" [routerLink]="['/user-details/', image.user_id ]">
                <div>
                  <user-profile [user]="getUserfromUserList(image.user_id)" [isName]="false"
                    [userImageClass]="userImageClass" [sizeAvatar]="34"></user-profile>
                </div>
                <div class="db-style-23">
                  <h4>{{ trimName(getUserName(image.user_id)) }}</h4>
                  @if (image.captured_time) {
                  <div class="screenshot-time-block" [matTooltip]="image.timeDisplay?.tooltip"
                    matTooltipClass="screenshot-time-tooltip" matTooltipShowDelay="400">
                    <p class="screenshot-time-primary">{{ image.timeDisplay?.primaryAbsolute || image.captured_time }}
                    </p>
                    @if (image.timeDisplay?.secondaryLine) {
                    <p class="screenshot-time-secondary">{{ image.timeDisplay.secondaryLine }}</p>
                    }
                  </div>
                  }
                </div>
              </div>
              <div class="col s12 m6 l5 xl5 badge-contain">
                <div class="badge">{{ image.type }}</div>
              </div>
            </div>
          </mat-card>
        </div>
        <!-- </ng-container> -->
      </div>

      <div *ngIf="total_ss == 0 && !loading" class="empty_list z-depth-2 remove-border" [ngStyle]="{
          display: !PhotoList.length ? 'block' : 'none',
          visibility: !PhotoList.length ? 'visible' : 'hidden'
        }">
        <img src="assets/images/empty_list.png" alt="empty list image" />
      </div>
    </div>

    <div class="pagination-div" *ngIf="total_ss != 0">
      <mat-paginator [length]="total_ss" [pageSize]="pageSize" [pageSizeOptions]="[25, 50, 100]"
        aria-label="Select page" (page)="onPageChange($event)" #EmpPaginator>
      </mat-paginator>
    </div>
  </mat-card>

</div>

<app-loader *ngIf="loading"></app-loader>